export default memoryStorage();
function memoryStorage() {
  let inMemoryStorage = {};
  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key,
    get length() {
      return length();
    }
  };
  function getItem(key) {
    return inMemoryStorage[key];
  }
  function setItem(key, value) {
    inMemoryStorage[key] = String(value);
  }
  function removeItem(key) {
    delete inMemoryStorage[key];
  }
  function clear() {
    inMemoryStorage = {};
  }
  function key(index) {
    return Object.keys(inMemoryStorage)[index] ?? null;
  }
  function length() {
    return Object.keys(inMemoryStorage).length;
  }
}